import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=3e5f19df&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=ts&"
export * from "./Transaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f19df",
  null
  
)

export default component.exports